import { Divider, Icon, SecondaryButton, useTranslation } from '@testsigma/atoms';

import { ConnectionFormBody } from '@modules/salesforce/shared/components/connection-form/connection-form-body';
import { ConnectionFailureNote } from '@modules/salesforce/shared/components/connection-form/connection-failure-note';

import { ConnectionFormHeader } from './header/connection-form-header';
import { UserNameAndPasswordFormAction } from './footer/username-and-password';
import { OAuthFormActions } from './footer/oauth';

import { useEditConnectionForm, useEditConnection } from '../../../hooks';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { SalesforceLoginMethod } from '@modules/salesforce/models';

const MetadataConnectionEditForm: React.FC = () => {
  const {
    watch,
    handleSubmit,
    values,
    isValid,
    isSaveOnlyMode,
    loginMethod,
    handleUpdateFormValue,
  } = useEditConnectionForm();
  
  const location = useLocation();
  const { t } = useTranslation(); 
  const [isTestConnection, setIsTestConnection] = useState(false);
  const isGlobalConnection =  location.pathname.includes('settings/salesforce_connections');

  const handleTestConnection = () => {
    setIsTestConnection(true);
  };
    
  const {
    isConnecting,
    hasConnectionFailed,
    handleUpdate,
    handleUsernamePasswordLogin,
    handleOAuthLogin,
    handleClose,
    testIsConnecting
  } = useEditConnection({ isSaveOnlyMode, isGlobalConnection, isTestConnection });

  useEffect(() => {
    if (!isTestConnection || !isValid) return;
    if (loginMethod === SalesforceLoginMethod.OAUTH) {
      handleSubmit(handleOAuthLogin)();
    } else if (loginMethod === SalesforceLoginMethod.USERNAME_PASSWORD) {
      handleSubmit(handleUsernamePasswordLogin)();
    } else {
      console.error('Unknown login method.');
    }
    setIsTestConnection(false);
  }, [isTestConnection]);
  
  const handleFormSubmit = (event) => {
    event.preventDefault();
  };



  return (
    <form onSubmit={handleFormSubmit}>
      <header>
        <ConnectionFormHeader />
      </header>

      <Divider type='solid' />

      <main>
        <ConnectionFailureNote hasConnectionFailed={hasConnectionFailed} />

        <ConnectionFormBody
          watch={watch}
          values={values}
          handleUpdateFormValue={handleUpdateFormValue}
        />
      </main>

      <Divider type='solid' />

      <footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '10px',
        }}
      >
        <SecondaryButton
          className='ml-5'
          onClick={handleTestConnection}
          disabled={!isValid || isConnecting}
        >
          <>
            {testIsConnecting ? (
              <div className='flex gap-x-1.5 items-center'>
                <Icon className='text-base flex animate-spin' name='loader' />
                {t('connecting.button.label')}
              </div>
            ) : (
              t('test.connection')
            )}
          </>
        </SecondaryButton>
        <UserNameAndPasswordFormAction
          loginMethod={loginMethod}
          isConnecting={isConnecting}
          isValid={isValid}
          isTestConnecting ={testIsConnecting}
          handleLogin={handleSubmit(handleUsernamePasswordLogin)}
          handleClose={handleClose}
          handleUpdate={isSaveOnlyMode ? handleSubmit(handleUpdate) : null}
        />
        <OAuthFormActions
          loginMethod={loginMethod}
          isConnecting={isConnecting}
          isValid={isValid}
          isTestConnecting ={testIsConnecting}
          handleLogin={handleSubmit(handleOAuthLogin)}
          handleClose={handleClose}
          handleUpdate={isSaveOnlyMode ? handleSubmit(handleUpdate) : null}
        />
      </footer>
    </form>
  );
};

export { MetadataConnectionEditForm };
